import React from 'react';
import PropTypes from 'prop-types';

function ISTwitterV2({ className, to }) {
  return (
    <a className={className} target={`_blank`} rel="noopener noreferrer" href={to}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.89687 11.7782L3.75 17.4399M16.25 3.68988L11.1031 9.3516M3.75 3.68988H7.5L16.25 17.4399H12.5L3.75 3.68988Z" stroke="#5A5A5A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </a>
  )
}

ISTwitterV2.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default ISTwitterV2;
